<template>
  <CContainer fluid>
    <h3>Precios Producto</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-6">
            <CInput 
              label="Buscar:" 
              addLabelClasses="text-muted font-weight-bold"
              :value.sync="searchWord" 
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" 
                  class="text-dark" 
                  @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol>
            <CButton v-if="$store.state.user.data.tipo_Empleado === 'A'"
              color="success"
              class="mt-4"
              @click="(e) => openPanelForm(e)">
              <i class="bi bi-plus-circle h4 mr-2"></i>
              <span>Agregar</span>
            </CButton>
          </CCol>
        </CRow>
        <CDataTable
          hover
          class="table-hover-icons"
          :responsive=true
          :fields="columns"
          :items="products"
          :noItemsView="{ noItems: '' }"
          :items-per-page="itemsPerPage">
          <template #sucursal="{item}">
            <td>
              <h4>{{ item.sucursal }}</h4>
              <!-- <div>
                <i class="bi bi-percent ml-2"></i>
              </div> -->
              <div>
                <i class="bi bi-info-circle mr-2"></i>
                <span>IVA: {{ item.tarifa_iva }} %</span>
              </div>
              <div v-if="item.activa_Promocion === 'V'">
                <div>
                  <span>Promocion activa</span>
                </div>
                <div>
                  <span>Descuento: {{ formatter.format(item.porcentaje_Promocion, 2) }} %</span>
                </div>
                <div>
                  <i class="bi bi-calendar-check text-success mr-2"></i>
                  <span>Desde: {{ moment(item.fecha_Inicial).format("DD/MM/YYYY") }}</span>
                </div>
                <div>
                  <i class="bi bi-calendar-x text-danger mr-2"></i>
                  <span>Hasta: {{ moment(item.fecha_Final).format("DD/MM/YYYY") }}</span>
                </div>
              </div>
            </td>
          </template>
          <template #detal="{item}">
            <td>
              <div class="d-flex justify-content-end">
                <span>$ {{ formatter.format(item.valor_Precio_D, 2) }}</span>
                <i class="bi bi-cash ml-2"></i>
              </div>
              <div class="d-flex justify-content-end">
                <strong>$ {{ formatter.format(item.valor_Precio_Iva_D, 2) }}</strong>
                <i class="bi bi-cash-coin ml-2"></i>
              </div>
            </td>
          </template>
          <template #mayor="{item}">
            <td>
              <div class="d-flex justify-content-end">
                <span>$ {{ formatter.format(item.valor_Precio_M, 2) }}</span>
                <i class="bi bi-cash ml-2"></i>
              </div>
              <div class="d-flex justify-content-end">
                <strong>$ {{ formatter.format(item.valor_Precio_Iva_M, 2) }}</strong>
                <i class="bi bi-cash-coin ml-2"></i>
              </div>
            </td>
          </template>
          <template #acciones="{item}">
            <td>
              <div class="d-flex justify-content-center">
                <div class="hover-actions">
                  <a href="#" v-if="$store.state.user.data.tipo_Empleado === 'A'"
                    v-c-tooltip="'Editar'"
                    @click="(e) => openPanelForm(e, item.id_Precio)">
                    <CIcon name="cil-pencil" class="text-warning hover-icon mr-2"/>
                  </a>
                  <a href="#" v-if="$store.state.user.data.tipo_Empleado === 'A'"
                    v-c-tooltip="'Eliminar'"
                    @click="(e) => tryDelete(e, item.id_Precio) ">
                    <CIcon name="cil-trash" class="text-danger hover-icon mr-2"></CIcon>
                  </a>
                </div>

                <!-- <a href="#"
                  style="text-decoration: none;"
                  class="mb-2 p-2"
                  v-on:click.stop.prevent="toggleDocument($event, item)">
                  <CIcon 
                    class="text-dark"
                    :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'" />
                </a> -->
              </div>
            </td>
          </template>
        </CDataTable>
        <CPagination
          size="sm"
          class="d-flex justify-content-center"
          :activePage.sync="page"
          :pages="pageCount"
          @update:activePage="(value, a) => getData(value, searchWord)"
        />
      </CCardBody>

      <LoadingCover v-show="loading" />
    </CCard>

    <RightSideBar size="md" class="bg-s3grey" :show="showPanelFormUpdate">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader class="bg-s3skyblue">
            <h4 class="mt-1">Registro Precio Producto</h4>
          </CCardHeader>
          <CCardBody>
            <VerticalDynamicForm :fields="productPriceFields">

            </VerticalDynamicForm>
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="success"
                @click="(e) => {
                  createProductPrice(e);
                }">
                <CIcon name="cil-check-circle" />
                <span class="align-middle ml-2">Guardar</span>
              </CButton>
              <CButton 
                color="danger"
                variant="outline"
                class="ml-2"
                @click="(e) => {
                  e.preventDefault();
                  e.stopPropagation();
    
                  showPanelFormUpdate = false;
                }">
                <CIcon name="cil-x-circle" />
                <span class="align-middle ml-2">Cerrar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>
  </CContainer>
</template>
<script>
  import { ref } from "vue";

  import LoadingCover from "@/components/containers/LoadingCover.vue";
  import RightSideBar from "@/components/containers/RightSideBar.vue";
  import VerticalDynamicForm from "@/components/containers/VerticalDynamicForm.vue";

  import moment from "moment";
  import CONSTANTS from "@/constants";
  import { 
    formatter
  } from "@/general";
  import { dataListSucursales } from "@/apiDataList";
  import { 
    dataGridPreciosProductos, 
    crudPreciosProductos 
  } from "@/apis/products";

  const columns = [
    { 
      key: "sucursal", 
      label: "Sucursal", 
      _style:"text-align:center;"
    },
    { 
      key: "detal", 
      label: "Valores Detal", 
      _style:"text-align:center;"
    },
    { 
      key: "mayor",
      label: "Valores Mayorista",
      _style:"text-align:center;"
    },
    {
      key: "acciones",
      label: "",
      _style:"text-align:center;"
    }
  ]

  export default {
    name: "ProductPricesList",
    components: {
      LoadingCover,
      RightSideBar,
      VerticalDynamicForm
    },
    data() {
      const self = this;
      return {
        formatter,
        loading: false,
        loadingAction: false,
        showPanelFormUpdate: null,
        updateComponent: 0,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        columns,
        products: [],
        productPriceFields: [
          {
            key: "sucursal",
            label: "Sucursal",
            value: "",
            type: "select",
            options: [],
            required: true,
            prepend_content: {
              name: "shop"
            }
          },
          {
            key: "iva_Incluido",
            label: "Activa IVA Incluido",
            value: false,
            type: "switch"
          },
          {
            key: "precio_Venta_Detal",
            label: "Valor Detal",
            value: 0,
            type: "text",
            required: true,
            prepend_content: {
              name: "cash-coin"
            }
          },
          {
            key: "precio_Venta_Mayorista",
            label: "Valor Mayorista",
            value: 0,
            type: "text",
            required: true,
            prepend_content: {
              name: "cash-coin"
            }
          },
          {
            key: "activa_Promocion",
            label: "Activa Promoción",
            value: false,
            type: "switch",
            on_change(value) {
              self.onChangeActivePromotion(value);
            }
          },
          {
            key: "porcentaje_Promocion",
            label: "Porcentaje Descuento",
            value: "",
            type: "text",
            disabled: true,
            prepend_content: {
              name: "percent"
            }
          },
          {
            key: "fecha_Inicial",
            label: "Fecha Inicial",
            value: "",
            type: "date",
            disabled: true,
            prepend_content: {
              name: "calendar-week"
            }
          },
          {
            key: "fecha_Final",
            label: "Fecha Final",
            value: "",
            type: "date",
            disabled: true,
            prepend_content: {
              name: "calendar-week"
            }
          },
          {
            key: "estado",
            label: "Estado",
            value: true,
            type: "switch"
          }
        ],
        isCreate: false,
        productPriceId: ""
      }
    },
    methods: {
      moment,
      async getData(page, search) {
        this.loading = true
        this.searchWord = search

        if (page !== this.page) {
          this.page = page
        }

        try {
          const filters = {
            "Id_Producto": this.productoId
          }

          const { count, results } = await dataGridPreciosProductos(this, page, search, filters);

          this.pageCount = parseInt(count / this.itemsPerPage);

          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++;
          } 
          
          this.products = results;
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar datos",
            show: 5
          });
        } finally{
          this.loading = false
        }
      },
      async getListBranches() {
        try {
          const response = await dataListSucursales(this);

          this.productPriceFields[0].options = [
            {
              value: "",
              label: "Seleccionar"
            },
            ...response.map(item => {
              return {
                value: item.id_Sucursal,
                label: item.nombre_Sucursal
              }
            })
          ]
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar los datos de Sucursales!",
            show: 5
          });
        }
      },
      openPanelForm(e, priceId) {
        e.preventDefault();
        e.stopPropagation();

        this.isCreate = priceId === undefined ? true : false;

        if (this.isCreate) {
            this.productPriceFields[0].value = "";
            this.productPriceFields[1].value = false;
            this.productPriceFields[2].value = 0;
            this.productPriceFields[3].value = 0;
            this.productPriceFields[4].value = false;
            this.onChangeActivePromotion(false);
        } else {
          this.productPriceId = priceId;
          this.readProductPrice();
        }

        this.showPanelFormUpdate = true;
      },
      async createProductPrice(e) {
        e.preventDefault();
        e.stopPropagation();

        this.loadingAction = true;

        try {
          const data = {
            "producto": this.productoId
          }

          this.productPriceFields.forEach(field => {
            if (field.key === "iva_Incluido" || field.key === "activa_Promocion") {
              data[field.key] = field.value ? "V" : "F";
              return;
            }

            if (field.key === "estado") {
              data[field.key] = field.value ? "A" : "I";
              return;
            }

            if (field.value.length > 0) {
              data[field.key] = field.value;
            }
          });

          if (this.isCreate) {
            await crudPreciosProductos(this, "create", null, data);
          } else {
            await crudPreciosProductos(this, "update", this.productPriceId, data);
          }

          this.getData();
        } catch(error) {
          console.log(error);
        } finally {
          this.loadingAction = false;
          this.showPanelFormUpdate = false;
        }
      },
      async readProductPrice() {
        const { errorCode, errorMessage, response} = await crudPreciosProductos(this, "read", this.productPriceId);

        errorCode
        errorMessage

        this.productPriceFields[0].value = response.sucursal;
        this.productPriceFields[1].value = response.iva_Incluido === "V" ? true : false;
        if (response.iva_Incluido === "V") {
          this.productPriceFields[2].value = response.valor_Precio_Iva_D;
          this.productPriceFields[3].value = response.valor_Precio_Iva_M;
        } else {
          this.productPriceFields[2].value = response.valor_Precio_D;
          this.productPriceFields[3].value = response.valor_Precio_M;
        }
        this.productPriceFields[4].value = response.activa_Promocion === "V" ? true : false;
        this.onChangeActivePromotion(this.productPriceFields[4].value);
        if (response.activa_Promocion === "V") {
          this.productPriceFields[5].value = response.porcentaje_Promocion;
          this.productPriceFields[6].value = moment(response.fecha_Inicial).format("YYYY-MM-DD");
          this.productPriceFields[7].value = moment(response.fecha_Final).format("YYYY-MM-DD");
        }
      },
      async updateProductPrice() {
        await crudPreciosProductos(this, "update", this.productPriceId);
      },
      tryDelete(e, priceId) {
        e.preventDefault();
        e.stopPropagation();

        this.productPriceId = priceId;

        CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar";
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "red";

        this.$confirm("¿Confirma que desea borrar el registro?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          this.deleteProductPrice();
        }).catch(() => {
          this.$alert("¡Se cancelo la acción!", "", "warning", CONSTANTS.configSimpleAlert);
        });
      },
      async deleteProductPrice() {
        await crudPreciosProductos(this, "delete", this.productPriceId);
        this.getData();
      },
      onChangeActivePromotion(value) {
        this.productPriceFields[5].disabled = !value;
        this.productPriceFields[6].disabled = !value;
        this.productPriceFields[7].disabled = !value;

        if (value) {
          this.productPriceFields[5].required = true;
          this.productPriceFields[5].value = 0;
          this.productPriceFields[6].value = moment().format("YYYY-MM-DD");
          this.productPriceFields[7].value = moment().add(7, "days").format("YYYY-MM-DD");
        } else {
          this.productPriceFields[5].value = "";
          this.productPriceFields[6].value = "";
          this.productPriceFields[7].value = "";
        }
      }
    },
    setup() {
      const rootPath = ref("");
      const productoId = ref("");

      return {
        rootPath,
        productoId
      }
    },
    async mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;
      this.productoId = this.$router.currentRoute.params.id;

      this.getData();
      this.getListBranches();
    }
  }
</script>
